import React from 'react'
import './Extracurriculars.css'
// other than portfolio talk about your extracurriculars
const Extracurriculars = () => {
  return (
    <section id = "extracurricular">Extracurriculars</section>
  )
}

export default Extracurriculars
